import { useNavigate } from "react-router-dom";
import { Avatar } from "../../ui";
import { mediaUrl } from "../../../utils/clientHeroTheme";
import { usePatientsBase } from "../../../utils/hubPaths";
import { clientStatusBadges } from "./clientSportDisplay";
import aa from "../AdminPortal/adminApp.module.css";
import s from "../clinic.module.css";

function membershipLabel(membership) {
  if (!membership) return null;
  if (membership.status === "pending") return "не оплачен";
  if (membership.plan_type === "visits" && membership.visits_remaining != null) {
    const n = membership.visits_remaining;
    return `${n} ${n === 1 ? "занятие" : n < 5 ? "занятия" : "занятий"} осталось`;
  }
  if (membership.plan_name) return membership.plan_name;
  return null;
}

function clientSubtitle(sport) {
  const parts = [];

  if (sport.groups?.length) {
    const primary = sport.groups[0];
    parts.push(
      sport.groups.length > 1 ? `${primary} +${sport.groups.length - 1}` : primary,
    );
  }

  const membership = membershipLabel(sport.membership);
  if (membership) {
    parts.push(membership);
  } else if (!sport.warnings?.includes("unpaid_membership")) {
    parts.push("без абонемента");
  }

  if (!parts.length) return "Без группы";
  return parts.join(" · ");
}

export default function ClientListCard({ client, variant = "default" }) {
  const navigate = useNavigate();
  const patientsBase = usePatientsBase();
  const sport = client?.sport || {};
  const badges = clientStatusBadges(sport);
  const badge = badges[0];
  const isApp = variant === "app";

  const openProfile = () => {
    navigate(`${patientsBase}/${client.id}`);
  };

  return (
    <article
      className={`${isApp ? aa.clientRow : s.clientCardSimple} ${
        sport.is_archived
          ? isApp
            ? aa.clientRowArchived
            : s.clientCardSimple_archived
          : ""
      }`}
    >
      <button
        type="button"
        className={isApp ? aa.clientRowBtn : s.clientCardSimpleBtn}
        onClick={openProfile}
      >
        <Avatar name={client.full_name} src={mediaUrl(client.photo_url)} size="md" />
        <span className={isApp ? aa.clientRowBody : s.clientCardSimpleBody}>
          <span className={isApp ? aa.clientRowTop : s.clientCardSimpleTop}>
            <strong className={isApp ? aa.clientRowName : s.clientCardSimpleName}>
              {client.full_name || "Без имени"}
            </strong>
            {badge ? (
              <span
                className={`${isApp ? aa.clientRowBadge : s.clientCardSimpleBadge} ${
                  isApp
                    ? aa[`clientRowBadge_${badge.tone}`]
                    : s[`clientCardSimpleBadge_${badge.tone}`]
                }`}
              >
                {badge.label}
              </span>
            ) : null}
          </span>
          <span className={isApp ? aa.clientRowMeta : s.clientCardSimpleMeta}>
            {clientSubtitle(sport)}
          </span>
          {client.phone ? (
            <span className={isApp ? aa.clientRowPhone : s.clientCardSimplePhone}>
              {client.phone}
            </span>
          ) : null}
        </span>
        <span
          className={isApp ? aa.clientRowChevron : s.clientCardSimpleChevron}
          aria-hidden
        />
      </button>
    </article>
  );
}
